export enum VehicleTypes {
    TOUR = "Passeio",
    MICROBUS = "Micro ônibus",
    SVU = "SVU",
}